<template>
  <div>
    <div class="owner_title">骗子库</div>
    <!-- 筛选 -->
    <div class="task_filtrate" @click="show_filter_form()">
      <i class="iconfont icon-shaixuan1"></i>
      <span>筛选</span>
    </div>

    <!-- 筛选表单 -->
    <div class="task_filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="写手QQ" prop="qq_account">
          <el-input v-model="filter_form.qq_account"></el-input>
        </el-form-item>
        <el-form-item label="写手支付宝" prop="alipay_account">
          <el-input v-model="filter_form.alipay_account"></el-input>
        </el-form-item>
        <el-button type="primary" @click="reset"
          >重置</el-button>
        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button>
      </el-form>
    </div>
    <div class="task_box">
      <el-table height="550" :data="cheaterList" border width="100%">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="name"
          label="写手昵称"
          align="center"
          sortable
          width="150"
        >
        </el-table-column>
        <el-table-column
          property="mobile"
          label="写手电话号码"
          align="center"
          sortable
          width="160"
        >
        </el-table-column>
        <el-table-column
          property="qq_account"
          label="写手QQ"
          align="center"
          sortable
          width="150"
        >
        </el-table-column>
        <el-table-column
          property="alipay_account"
          label="写手支付宝"
          align="center"
          sortable
          width="200"
        >
        </el-table-column>
        <el-table-column
          property="status"
          label="写手状态"
          align="center"
          sortable
          width="130"
        >
          <!-- 0=新入库红色，1=合作中蓝色，2=合作过绿色 -->
          <el-tag>
            <div class="tag_circle tag_blue"></div>
            未合作
          </el-tag>
        </el-table-column>
        <el-table-column label="写手标签" align="center" sortable width="140">
          <template slot-scope="scope">
            <el-tag
              :key="item"
              v-for="item in scope.row.connectionlabel_text"
              type="info"
              >{{ item }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          property="connectionremark_text"
          label="批注"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="departmentuser_nickname"
          label="录入编辑"
          align="center"
          sortable
          width="150"
        ></el-table-column>
        <el-table-column
          property="is_task"
          label="是否有任务"
          align="center"
          sortable
          width="120"
        >
          <el-tag type="info">
            无任务
          </el-tag>
        </el-table-column>
        <el-table-column
          property="createtime"
          label="设置标签时间"
          align="center"
          width="200"
          sortable
        >
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { pz_writer_tabulation } from "@/utils/writer";
export default {
  data() {
    return {
      baseUrl: this.$global.commonUrl, //路径
      writerId: "", //金主所需部门id
      cheaterList: [], //骗子列表
      dataShow: [], // 当前页要显示的数据,
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 20, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      isFilterForm: true, // 筛选表单
      // 筛选
      filter_form: {
        qq_account: "", //写手QQ
        alipay_account:"",
      }
    };
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.getCheaterList(); //任务中心列表
  },
  methods: {
    // 获取书籍下载列表
    getCheaterList() {
      var that = this;
      let obj = {
        currentPage: that.currentPage,
        pageSize: that.pageSize,
        departmentuser_id: that.writerId
      };
      pz_writer_tabulation(obj).then(res => {
        if (res.data.code == 1) {

          that.total = res.data.msg;
          that.cheaterList = res.data.data;
          // that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 重置
    reset(){
      this.filter_form.qq_account=""
      this.filter_form.alipay_account=""
      this.goSearch()
    },
    // 筛选
    goSearch() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        qq_account: that.filter_form.qq_account,
        currentPage: that.currentPage,
        pageSize: that.pageSize,
        alipay_account: that.filter_form.alipay_account
      };
      pz_writer_tabulation(obj).then(res => {
        if (res.data.code === 1) {
          that.total = res.data.msg;
          that.cheaterList = res.data.data;
          // that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // calcPageData() {
    //   if (this.cheaterList.length > 1) {
    //     this.pageNum = Math.ceil(this.cheaterList.length / this.pageSize) || 1;
    //   }
    //   for (let i = 0; i < this.pageNum; i++) {
    //     this.totalPageData[i] = this.cheaterList.slice(
    //       this.pageSize * i,
    //       this.pageSize * (i + 1)
    //     );
    //   }
    //   this.dataShow = this.totalPageData[this.currentPage - 1];
    // },
    handleSizeChange(val) {
      this.pageSize = val;
      // this.calcPageData();
      this.goSearch();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // this.dataShow = this.totalPageData[val - 1];
      this.goSearch();
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}

.sea_tag .el-tag.el-tag--info {
  width: 90px;
  margin: 5px auto;
}
.remark_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
}
.remark_btn i {
  font-size: 12px;
}
.task_box {
  margin: 0px 15px;
}
.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}
.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.task_filter_form {
  background: #ffffff;
  margin: 0px 16px;
  padding-top: 15px;
}

.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.myowner_btn {
  width: 110px;
  height: 20px;
  line-height: 20px;
  background: #157df8;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  border-radius: 17px;
  margin-right: 5px;
}
.highSeas_box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.sea_tag {
  text-align: center;
}
.task_box .el-tag {
  width: 90px;
  margin: 5px auto;
}
.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 20px;
  border-radius: 10px;
  margin-left: 15px;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .task_box {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/writer/WriterCheaterPool.vue